export default {
    header_menu: {
        home: "Home",
        about: "About Us",
        //产品
        product: "Products",
        //新闻
        news: "News",
        news_content: "News Content",
        //下载中心
        download: "Download Center",
        //联系我们
        contact: "Contact Us",
    },
    read_more: "Read More",
    prev: "Previous article",
    next: "Next article",
    quick_navigation: "Quick Navigation",
    phone: "Tel",
    whatsapp: "WhatsApp",
    email: "Email",
    address: "Address",
    your_name: "Your name",
    your_email: "Your email",
    content: "Content",
    please_input: "Please input ",
    leave_message: "Send an Inquiry",
    leave_success: "Message sent successfully",
    click_count: "Click count",
    create_time: "Create time",
    upload_time: "Upload time",
    download: "Download",
    resources: "Resources",
    products_type1: "Product Categories",
    products_type2: "Subcategories",
    products_type3: "Subcategories",
    products_list: "Product list",
    products_detail: "Product details",
    products_video: "Product video",
    send_message: "Send Inquiry",
    products_content: "Product content",
    categories: "Categories",
    send_email: "Send E-Mail",
    call_time: "Service Hours",
    our_location: "Our Location",
    leave_message_to_us: "Send us an inquiry",
    left_category: "Categories",
    type_two: "Subcategories",
    type_three: "Subcategories",
    video_not_support: "Your browser does not support the video tag.",
    about_us: "About Us",
    no_data: "No data",
    home_about_subtitle: "A trusted supplier of premium timber & plywood for global buyers",
    home_products_title: "Our Products",
    home_products_subtitle: "Explore our core product categories",
    view_all: "View All",
    home_stat_countries: "Countries Served",
    home_stat_capacity: "Annual Output (m³)",
    home_stat_years: "Years of Experience",
    home_stat_clients: "Global Clients",
    footer_follow: "Follow us on WeChat",
    footer_wechat: "WeChat",
    footer_copyright: "Debai Wood. All rights reserved.",
    home_visual_year: "Since 2009",
    home_visual_quote: "Trusted timber & plywood partner for buyers across 60+ countries.",
    home_visual_tag: "FSC · ISO 9001 · CE Certified",
    cta_title: "Looking for Reliable Timber & Plywood Supply?",
    cta_sub: "Get a competitive quote and worldwide delivery for your bulk timber orders.",
    get_a_quote: "Get a Quote",
    home_banner_title: "Premium Timber & Plywood for the World",
    home_banner_sub: "Trusted global supplier serving 60+ countries with FSC, ISO 9001 & CE certified quality.",
    topbar_slogan: "Premium Timber & Plywood — Trusted by Buyers Worldwide",
    contact_hero_tag: "Get In Touch",
    page_title: {
        home: "Debai Wood | Timber & Plywood Manufacturer & Global Supplier",
        about: "About Us | Debai Wood",
        products: "Products | Debai Wood",
        news: "News | Debai Wood",
        download: "Download Center | Debai Wood",
        contact: "Contact Us | Debai Wood",
        not_found: "Page Not Found",
        back_home: "Back to Home",
    },
    page_desc: {
        home: "Debai Wood is a leading timber & plywood manufacturer and global supplier, serving 60+ countries with FSC, ISO 9001 and CE certified wood products and worldwide delivery.",
        about: "Learn about Debai Wood — a trusted timber & plywood manufacturer with 15+ years of experience, global clients and certified quality management.",
        products: "Explore Debai Wood's full range of timber & plywood products: film faced plywood, OSB, MDF, sawn lumber and customized solutions for global buyers.",
        news: "Latest news, exhibitions and industry insights from Debai Wood — your trusted timber & plywood partner.",
        download: "Download Debai Wood product catalogs, certifications (FSC, ISO 9001, CE) and technical datasheets for timber & plywood.",
        contact: "Contact Debai Wood for competitive quotes on bulk timber & plywood orders. Worldwide delivery and dedicated B2B support.",
    },
};
